export const prs = {
  title: 'نمونه هایی از محدودیت های طالبان بر زنان افغان در سه سال گذشته: ',
  intro:
    'طالبان در ابتدا تعهد کرده بودند که در چارچوب شریعت به حقوق زنان احترام خواهند کرد اما پس از به قدرت رسیدن، فرمان های را صادر کردند که بطور مداوم آموزش، کار، فعالیت های سیاسی و اجتماعی و سفر زنان را محدود کرد.  چند نمونه ای از این محدودیت ها را اینجا دیده می توانید.  ',
  timeline: {
    title: 'جدول زمانی',
    hint: 'برای مشاهده جزئیات بیشتر، روی یک آیتم جدول زمانی کلیک کنید',
  },
  footer: {
    followUs: 'به ما بپیوندید',
    copyright: 'همۀ حقوق چاپ و کاپی رایت این سایت برای رادیو آزادی محفوظ است',
    aboutTitle: 'در مورد گزارش',
    about: ['گزارش: ملالی بشیر', 'ترجمه: فرشته نگاه', 'پنجیا داتا ویز تیم'],
    social: {
      instagram: 'https://www.instagram.com/radioazadi_da/',
      youtube: 'https://www.youtube.com/user/Azadiradio',
      x: 'https://twitter.com/DaRadioAzadi',
      facebook: 'https://facebook.com/Azadir',
    },
  },
}
